import { render, staticRenderFns } from "./mbcheckbox.vue?vue&type=template&id=332c90fb&"
import script from "./mbcheckbox.vue?vue&type=script&lang=js&"
export * from "./mbcheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports